var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "navbar-search", attrs: { action: "/search" } },
    [
      _c(
        "div",
        { staticClass: "navbar-search__wrapper" },
        [
          _c(
            "div",
            {
              staticClass:
                "text-input text-input--full-width navbar-search__field"
            },
            [
              _c(
                "label",
                {
                  staticClass: "text-input__label u-sr-only",
                  attrs: { for: "search-input" }
                },
                [_vm._v("Search")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchValue,
                    expression: "searchValue"
                  }
                ],
                ref: "input",
                staticClass: "text-input__input",
                attrs: {
                  "aria-label": "Search",
                  type: "text",
                  name: "q",
                  placeholder: _vm.searchPlaceholder
                },
                domProps: { value: _vm.searchValue },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    return _vm.tab.apply(null, arguments)
                  },
                  focus: function($event) {
                    return _vm.$emit("open-results")
                  },
                  blur: _vm.blur,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchValue = $event.target.value
                  }
                }
              })
            ]
          ),
          _c(
            "base-button",
            {
              staticClass: "button--icon navbar-search__submit",
              attrs: { type: "submit" }
            },
            [
              _c("div", { staticClass: "u-sr-only" }, [_vm._v("Search")]),
              _c("icon", {
                staticClass: "button__icon",
                attrs: {
                  name: "arrow-right-long",
                  width: "30px",
                  height: "12px"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }